import { render, staticRenderFns } from "./UserPermission.vue?vue&type=template&id=157c349d&scoped=true"
import script from "./UserPermission.vue?vue&type=script&lang=js"
export * from "./UserPermission.vue?vue&type=script&lang=js"
import style0 from "./UserPermission.vue?vue&type=style&index=0&id=157c349d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157c349d",
  null
  
)

export default component.exports